import API from 'app/gamma/src/api';
import { Action, actionCreator } from '@trello/redux';

import { MemberResponse } from 'app/gamma/src/types/responses';
import { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
import { State } from 'app/gamma/src/modules/types';

export const LOAD_MEMBER_ACTIVITY_REQUEST = Symbol(
  'loaders/LOAD_MEMBER_ACTIVITY_REQUEST',
);
export const LOAD_MEMBER_ACTIVITY_SUCCESS = Symbol(
  'loaders/LOAD_MEMBER_ACTIVITY_SUCCESS',
);
export const LOAD_MEMBER_ACTIVITY_ERROR = Symbol(
  'loaders/LOAD_MEMBER_ACTIVITY_ERROR',
);

export type LoadMemberActivityRequestAction = Action<
  typeof LOAD_MEMBER_ACTIVITY_REQUEST,
  string
>;

export type LoadMemberActivitySuccessAction = Action<
  typeof LOAD_MEMBER_ACTIVITY_SUCCESS,
  MemberResponse
>;

export type LoadMemberActivityErrorAction = Action<
  typeof LOAD_MEMBER_ACTIVITY_ERROR,
  Error
>;

// Action creators
const loadMemberActivityRequest = actionCreator<
  LoadMemberActivityRequestAction
>(LOAD_MEMBER_ACTIVITY_REQUEST);
const loadMemberActivitySuccess = actionCreator<
  LoadMemberActivitySuccessAction
>(LOAD_MEMBER_ACTIVITY_SUCCESS);
const loadMemberActivityError = actionCreator<LoadMemberActivityErrorAction>(
  LOAD_MEMBER_ACTIVITY_ERROR,
);

export const loadMemberActivity = (
  idMemberOrUsername: string,
): StandardThunkAction => {
  return async (dispatch: Dispatch, getState: () => State) => {
    try {
      dispatch(loadMemberActivityRequest(idMemberOrUsername));

      const member = await API.client.rest.get<MemberResponse>(
        `members/${idMemberOrUsername}`,
        {
          query: {
            actions: 'all',
            actions_display: true,
            actions_limit: 10,
            organizations: 'all',
          },
        },
      );

      dispatch(loadMemberActivitySuccess(member));
    } catch (err) {
      dispatch(loadMemberActivityError(err));
    }
  };
};
